export const GTM_EVENTS = {
  CTA_CLICK: 'cta_click',
  CONTACT_REQUEST: 'contact_request',
  CONTACT_SUBMIT: 'contact_form_submit',
  WHATSAPP_CLICK: 'whatsapp_click',
};

export const GTM_SOURCES = {
  NAVBAR: 'navbar',
  NAVBAR_MOBILE: 'navbar_mobile',
  HERO: 'hero',
  SERVICIOS: 'servicios',
  CONTACTO_HERO: 'contacto_hero',
  CONTACTO_FORM: 'contacto_form',
  FOOTER: 'footer',
};
